import { render, staticRenderFns } from "./SettingsItem.vue?vue&type=template&id=0d728422&scoped=true&"
import script from "./SettingsItem.vue?vue&type=script&lang=js&"
export * from "./SettingsItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingsItem.vue?vue&type=style&index=0&id=0d728422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d728422",
  null
  
)

export default component.exports